import styled from "@emotion/styled";
import React from "react";
import { AppCaregiver } from "../../../system/AppState/AppCaregiverState";
import { getFullName } from "../../../utils/getFullName";
import AsyncImage from "../../Generic/AsyncImage";
import { getCaregiverPhotoUrl } from "../main-utils";

type Props = {
  caregiver: Pick<AppCaregiver, "firstName" | "lastName" | "photoUrl" | "address">;
};

function CaregiverMapCard(props: Props, ref: React.Ref<HTMLDivElement>) {
  return (
    <CaregiverCardRoot ref={ref}>
      <CaregiverPhoto src={getCaregiverPhotoUrl(props.caregiver)} />
      <BackgroundWrapper>
        <BackgroundPhoto src={getCaregiverPhotoUrl(props.caregiver)} />
        <BackgroundDimmer />
      </BackgroundWrapper>

      <Content>
        <Name>{getFullName(props.caregiver)}</Name>
        <Address>{props.caregiver.address}</Address>
      </Content>
    </CaregiverCardRoot>
  );
}

export default React.forwardRef(CaregiverMapCard);

const Content = styled.div`
  padding: 24px;
  position: relative;
  z-index: 1;
`;

const Name = styled.h3`
  margin: 0;
  padding: 0;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  color: var(--tw-slate-900);
`;

const Address = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  color: var(--tw-slate-400);
`;

const CaregiverPhoto = styled.img`
  --size: 80px;
  width: var(--size);
  height: var(--size);
  background-color: var(--tw-slate-900);
  object-fit: cover;
  object-position: 50% 50%;
  border-radius: 25%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transform: translate(0, -33.333%);
  margin: auto;
  z-index: 1;
`;

const BackgroundWrapper = styled.div`
  border-radius: 16px 16px 0 0;
  background-color: rgba(0, 0, 0, 0.75);
  height: 80px;
  overflow: hidden;
  position: relative;
`;

const BackgroundDimmer = styled.div`
  background-color: var(--tw-slate-900);
  border-radius: 16px 0 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.5;
`;

const BackgroundPhoto = styled(AsyncImage)`
  background-size: cover;
  background-position: center;
  filter: blur(16px);
  transform: scale(1.5);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const CaregiverCardRoot = styled.div`
  background-color: white;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  position: relative;
`;
